// ../connect-button/dist/connect-button.js
import { css as d, LitElement as I, html as g, unsafeCSS as c } from "lit";
import { property as s, customElement as p, state as It } from "lit/decorators.js";
import { classMap as u } from "lit/directives/class-map.js";
import { styleMap as K } from "lit/directives/style-map.js";
import { classMap as q } from "lit-html/directives/class-map.js";
var pt = d`:host{--color-radix-green-1:#00ab84;--color-radix-green-2:#00c389;--color-radix-green-3:#21ffbe;--color-radix-blue-1:#060f8f;--color-radix-blue-2:#052cc0;--color-radix-blue-3:#20e4ff;--color-light:#ffffff;--color-dark:#000000;--color-accent-red:#ef4136;--color-accent-blue:#00aeef;--color-accent-yellow:#fff200;--color-alert:#e59700;--color-radix-error-red-1:#c82020;--color-radix-error-red-2:#fcebeb;--color-grey-1:#003057;--color-grey-2:#8a8fa4;--color-grey-3:#ced0d6;--color-grey-4:#e2e5ed;--color-grey-5:#f4f5f9}`;
var H = d`:host{font-family:'IBM Plex Sans',system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Open Sans','Helvetica Neue',sans-serif}:host([mode=light]){--radix-popover-background:color-mix(in srgb, #efefef 50%, transparent);--radix-popover-border-color:var(--color-grey-3);--radix-popover-text-color:var(--color-grey-1);--radix-popover-tabs-background:color-mix(
      in srgb,
      var(--color-grey-2) 15%,
      transparent
    );--radix-popover-tabs-button-active-background:var(--color-light);--radix-link-color:var(--color-radix-blue-2);--radix-card-background:var(--color-light);--radix-card-text-color:var(--color-grey-1);--radix-card-text-dimmed-color:var(--color-grey-2);--radix-card-inverted-background:var(--color-grey-1);--radix-card-inverted-text-color:var(--color-light);--radix-avatar-border-color:var(--color-grey-5);--radix-mask-background:color-mix(
      in srgb,
      var(--color-light) 50%,
      transparent
    );--radix-button-background:color-mix(
      in srgb,
      var(--color-light) 80%,
      transparent
    );--radix-button-background-hover:var(--color-light);--radix-button-background-pressed:var(--color-grey-5);--radix-button-text-color:var(--color-radix-blue-2);--radix-button-disabled-background:color-mix(
      in srgb,
      var(--color-light) 80%,
      transparent
    );--radix-button-disabled-text-color:var(--color-grey-3);color:var(--color-grey-1)}:host([mode=dark]){--radix-popover-background:color-mix(in srgb, #000000 50%, transparent);--radix-popover-border-color:var(--color-dark);--radix-popover-text-color:var(--color-light);--radix-popover-tabs-background:color-mix(
      in srgb,
      var(--color-dark) 60%,
      transparent
    );--radix-popover-tabs-button-active-text-color:var(--color-light);--radix-popover-tabs-button-active-background:#515151;--radix-link-color:var(--color-white);--radix-card-background:#515151;--radix-card-text-color:var(--color-light);--radix-card-text-dimmed-color:var(--color-grey-3);--radix-card-inverted-background:var(--color-grey-5);--radix-card-inverted-text-color:var(--color-grey-1);--radix-avatar-border-color:#656565;--radix-mask-background:color-mix(
      in srgb,
      var(--color-dark) 40%,
      transparent
    );--radix-button-background:color-mix(
      in srgb,
      var(--color-dark) 40%,
      transparent
    );--radix-button-background-hover:var(--color-dark);--radix-button-background-pressed:#414141;--radix-button-text-color:var(--color-light);--radix-button-disabled-background:color-mix(
      in srgb,
      var(--color-dark) 40%,
      transparent
    );--radix-button-disabled-text-color:color-mix(
      in srgb,
      var(--color-light) 20%,
      transparent
    );color:var(--color-light)}:host([theme=radix-blue]){--radix-connect-button-background:var(--color-radix-blue-2);--radix-connect-button-background-hover:var(--color-radix-blue-1);--radix-connect-button-border-color:var(--color-radix-blue-2);--radix-connect-button-text-color:var(--color-light)}:host([theme=black]){--radix-connect-button-background:var(--color-dark);--radix-connect-button-background-hover:#3e3e3e;--radix-connect-button-border-color:var(--color-dark);--radix-connect-button-text-color:var(--color-light)}:host([theme=white-with-outline]){--radix-connect-button-background:var(--color-light);--radix-connect-button-background-hover:var(--color-grey-5);--radix-connect-button-border-color:var(--color-dark);--radix-connect-button-text-color:var(--color-dark)}:host([theme=white]){--radix-connect-button-background:var(--color-light);--radix-connect-button-background-hover:var(--color-grey-5);--radix-connect-button-border-color:var(--color-light);--radix-connect-button-text-color:var(--color-dark)}`;
var Ct = Object.defineProperty;
var yt = Object.getOwnPropertyDescriptor;
var Mt = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? yt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Ct(i, r, e), e;
};
var U = class extends I {
  constructor() {
    super(...arguments), this.active = "sharing";
  }
  onClick(t, i) {
    this.dispatchEvent(
      new CustomEvent("onClick", {
        detail: { value: t, event: i },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return g`<div class="tabs"><button @click="${(t) => this.onClick("sharing", t)}" class="${u({
      active: this.active === "sharing"
    })}">Sharing</button> <button @click="${(t) => this.onClick("requests", t)}" class="${u({
      active: this.active === "requests"
    })}">Requests</button><div class="active-indicator"></div></div>`;
  }
};
U.styles = [
  d`:host{display:block;width:100%;user-select:none}.tabs{width:calc(100% - 10px);display:grid;grid-template-columns:1fr 1fr;justify-content:space-between;padding:5px;border-radius:12px;position:relative;background:var(--radix-popover-tabs-background)}button{border:unset;font-size:14px;background:0 0;text-align:center;flex:1;border-radius:8px;font-weight:600;color:var(--radix-popover-text-color);width:100%;height:32px;z-index:1;margin:0;padding:0}button:not(.active){cursor:pointer}.active-indicator{width:calc(50% - 5px);height:32px;border-radius:8px;position:absolute;box-shadow:0 4px 5px 0 #0000001a;background:var(--radix-popover-tabs-button-active-background);top:5px;transition:transform 125ms cubic-bezier(.45,0,.55,1)}:host([active=sharing]) .active-indicator{transform:translateX(5px)}:host([active=requests]) .active-indicator{transform:translateX(calc(100% + 5px))}button:focus,button:focus-visible{outline:0 auto -webkit-focus-ring-color}`
];
Mt([
  s({
    type: String,
    reflect: true
  })
], U.prototype, "active", 2);
U = Mt([
  p("radix-tabs-menu")
], U);
var mt = (t) => {
  if (typeof btoa == "function")
    return btoa(t);
  if (typeof Buffer == "function")
    return Buffer.from(t, "utf-8").toString("base64");
  throw new Error("Failed to determine the platform specific encoder");
};
var $ = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xNzU4XzE0NjkpIj4KICAgICAgICA8cGF0aAogICAgICAgICAgICBkPSJNMTkgNi40MUwxNy41OSA1TDEyIDEwLjU5TDYuNDEgNUw1IDYuNDFMMTAuNTkgMTJMNSAxNy41OUw2LjQxIDE5TDEyIDEzLjQxTDE3LjU5IDE5TDE5IDE3LjU5TDEzLjQxIDEyTDE5IDYuNDFaIgogICAgICAgICAgICBmaWxsPSIjMzIzMjMyIiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8xNzU4XzE0NjkiPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIiAvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPgogICAg";
var zt = Object.defineProperty;
var wt = Object.getOwnPropertyDescriptor;
var Z = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? wt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && zt(i, r, e), e;
};
var j = class extends I {
  constructor() {
    super(...arguments), this.connected = false, this.compact = false, this.isMobile = false, this.showCloseButton = false, this.svgBorder = `data:image/svg+xml;base64,${mt('<svg width="352" height="352" viewBox="0 0 352 352" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1.5H339V0.5H13V1.5ZM350.5 13V339H351.5V13H350.5ZM339 350.5H13V351.5H339V350.5ZM1.5 339V13H0.5V339H1.5ZM13 350.5C6.64873 350.5 1.5 345.351 1.5 339H0.5C0.5 345.904 6.09644 351.5 13 351.5V350.5ZM350.5 339C350.5 345.351 345.351 350.5 339 350.5V351.5C345.904 351.5 351.5 345.904 351.5 339H350.5ZM339 1.5C345.351 1.5 350.5 6.64873 350.5 13H351.5C351.5 6.09644 345.904 0.5 339 0.5V1.5ZM13 0.5C6.09644 0.5 0.5 6.09644 0.5 13H1.5C1.5 6.64873 6.64873 1.5 13 1.5V0.5Z" fill="url(#gradient)"/><defs><linearGradient id="gradient" x1="340.017" y1="27.6666" x2="36.936" y2="352.447" gradientUnits="userSpaceOnUse"><stop stop-color="#CE0D98"/><stop offset="0.210873" stop-color="#052CC0"/><stop offset="0.479167" stop-color="#20E4FF"/><stop offset="0.729604" stop-color="#052CC0"/><stop offset="1" stop-color="#21FFBE"/></linearGradient></defs></svg>')}`;
  }
  closePopover() {
    this.dispatchEvent(
      new CustomEvent("onClosePopover", {
        bubbles: true,
        composed: true
      })
    );
  }
  closeButton() {
    return g`<button id="close-button" @click="${() => {
      this.closePopover();
    }}"></button>`;
  }
  render() {
    return g`<style>:host([connected]){border-image:url('${this.svgBorder}') 10/10px stretch;border-image-outset:1px}</style><div id="radix-popover-content">${this.showCloseButton ? this.closeButton() : ""}<slot></slot></div>`;
  }
};
j.styles = [
  H,
  d`:host{user-select:none;display:inline-flex;background-position:center top;background-repeat:no-repeat;justify-content:center;align-items:flex-start;background:var(--radix-popover-background);backdrop-filter:blur(30px);-webkit-backdrop-filter:blur(30px);box-sizing:border-box;max-height:100vh;border-radius:12px;padding:12px;border:1px solid var(--radix-popover-border-color);box-shadow:0 11px 35px 0 #00000047}:host([isMobile]){max-width:100%;max-height:calc(100% - 5px)}#radix-popover-content{width:344px;display:flex;justify-content:flex-start;align-items:center;flex-direction:column;overflow:auto}#close-button{-webkit-mask-image:url('${c($)}');mask-image:url('${c($)}');background-color:var(--radix-card-text-color);width:24px;height:24px;background-repeat:no-repeat;align-self:flex-start;margin-bottom:10px;cursor:pointer}#close-button:hover{opacity:.8}@-webkit-keyframes slide-bottom{0%{-webkit-transform:translateY(-10px);transform:translateY(-10px);opacity:0}100%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@keyframes slide-bottom{0%{-webkit-transform:translateY(-10px);transform:translateY(-10px);opacity:0}100%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@-webkit-keyframes slide-up{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}100%{-webkit-transform:translateY(-10px);transform:translateY(-10px);opacity:0}}@keyframes slide-up{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}100%{-webkit-transform:translateY(-10px);transform:translateY(-10px);opacity:0}}:host(.hide){pointer-events:none;-webkit-animation:slide-up .2s cubic-bezier(.25,.46,.45,.94) both;animation:slide-up .2s cubic-bezier(.25,.46,.45,.94) both}:host(.show){-webkit-animation:slide-bottom .2s cubic-bezier(.25,.46,.45,.94) both;animation:slide-bottom .2s cubic-bezier(.25,.46,.45,.94) both}`
];
Z([
  s({
    type: Boolean
  })
], j.prototype, "connected", 2);
Z([
  s({
    type: Boolean
  })
], j.prototype, "compact", 2);
Z([
  s({
    type: Boolean,
    reflect: true
  })
], j.prototype, "isMobile", 2);
Z([
  s({
    type: Boolean,
    reflect: true
  })
], j.prototype, "showCloseButton", 2);
j = Z([
  p("radix-popover")
], j);
var vt = 32;
var Tt = 32;
var G = 138;
var Lt = Object.defineProperty;
var kt = Object.getOwnPropertyDescriptor;
var R = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? kt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Lt(i, r, e), e;
};
var _ = g`<div class="loading-spinner-container"><div class="loading-spinner"></div></div>`;
var ft = d`.loading-spinner-container{display:flex}@container (max-width: ${G - 16}px){margin-right:0}.loading-spinner{width:22px;height:22px;min-width:22px;min-height:22px;border:2px solid var(--radix-connect-button-text-color);border-left-color:color-mix(in srgb,var(--radix-connect-button-text-color) 30%,transparent);border-top-color:color-mix(in srgb,var(--radix-connect-button-text-color) 30%,transparent);border-bottom-color:color-mix(in srgb,var(--radix-connect-button-text-color) 30%,transparent);border-radius:50%;display:inline-block;box-sizing:border-box;animation:rotation 1s linear infinite;align-self:center}@keyframes rotation{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`;
var w = class extends I {
  constructor() {
    super(...arguments), this.size = 48, this.weight = 5, this.color = "var(--color-grey-2)";
  }
  render() {
    return g`<div class="loading-spinner-container"><div class="loading-spinner" style="${K({
      width: `${this.size}px`,
      height: `${this.size}px`,
      minWidth: `${this.size}px`,
      minHeight: `${this.size}px`,
      border: `${this.weight}px solid color-mix(in srgb, ${this.color} 30%, transparent)`,
      borderBottomColor: this.color
    })}"></div></div>`;
  }
};
w.styles = [
  d`.loading-spinner-container{display:flex}.loading-spinner{border-radius:50%;display:inline-block;box-sizing:border-box;animation:rotation 1s linear infinite;align-self:center}@keyframes rotation{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`
];
R([
  s({
    type: Number
  })
], w.prototype, "size", 2);
R([
  s({
    type: Number
  })
], w.prototype, "weight", 2);
R([
  s({
    type: String
  })
], w.prototype, "color", 2);
w = R([
  p("radix-loading-spinner")
], w);
var tt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzYzNzEgMTEuNzE4M0M1LjUxNDM0IDExLjcxODMgNS4yNzcyNiAxMS41OTg2IDUuMTI4NjIgMTEuMzkyNUwyLjAyNDQyIDcuMDcwOTdIMFY1LjQ5NzU4SDIuNDI0ODhDMi42NzY3MSA1LjQ5NzU4IDIuOTEyNTYgNS42MTg1MiAzLjA1OTk3IDUuODIzMzdMNS41OTY2NCA5LjM1MzkxTDkuNDY3MzcgMC40NzEzOThDOS41OTI2NiAwLjE4NTEwNCA5Ljg3Mzk3IDAgMTAuMTg0OCAwSDE1LjAyMzVWMS41NzMzOEgxMC42OTdMNi40ODExIDExLjI0NjlDNi4zNjgwOSAxMS41MDYxIDYuMTI2MDkgMTEuNjgzOCA1Ljg0NjAxIDExLjcxMzRDNS44MjAyMSAxMS43MTcxIDUuNzkxOTYgMTEuNzE4MyA1Ljc2MzcxIDExLjcxODNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
var St = "data:image/svg+xml;base64,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";
var Et = "data:image/svg+xml;base64,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";
var et = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC40IiB5PSIwLjQiIHdpZHRoPSIyMS4yIiBoZWlnaHQ9IjIxLjIiIHJ4PSIxMC42IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuOCIvPgo8bWFzayBpZD0ibWFzazBfMTg5N18xODg5IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiPgo8cmVjdCB4PSIwLjI0OTc1NiIgeT0iMC41IiB3aWR0aD0iMjEuNTExIiBoZWlnaHQ9IjIxLjUxMSIgcng9IjEwLjc1NTUiIGZpbGw9IiNGNEY1RjkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzE4OTdfMTg4OSkiPgo8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjguODc0MDIiIGN5PSI5LjEyNSIgcj0iMy45NzUiIHN0cm9rZT0iI0NFRDBENiIgc3Ryb2tlLXdpZHRoPSIwLjgiLz4KPGNpcmNsZSBvcGFjaXR5PSIwLjIiIGN4PSIxMy4xMjQzIiBjeT0iOS4xMjUiIHI9IjMuOTc1IiBzdHJva2U9IiNDRUQwRDYiIHN0cm9rZS13aWR0aD0iMC44Ii8+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZD0iTTIxLjM0OTMgMjEuNUMyMS4zNDkzIDI1LjMwMzQgMTguNDMwNiAyOC4zNSAxNC44NzQzIDI4LjM1QzExLjMxOCAyOC4zNSA4LjM5OTI3IDI1LjMwMzQgOC4zOTkyNyAyMS41QzguMzk5MjcgMTcuNjk2NiAxMS4zMTggMTQuNjUgMTQuODc0MyAxNC42NUMxOC40MzA2IDE0LjY1IDIxLjM0OTMgMTcuNjk2NiAyMS4zNDkzIDIxLjVaIiBzdHJva2U9IiNDRUQwRDYiIHN0cm9rZS13aWR0aD0iMC44Ii8+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZD0iTTEzLjM0OTUgMjEuNUMxMy4zNDk1IDI1LjMwMzQgMTAuNDMwOCAyOC4zNSA2Ljg3NDUxIDI4LjM1QzMuMzE4MjIgMjguMzUgMC4zOTk1MTIgMjUuMzAzNCAwLjM5OTUxMiAyMS41QzAuMzk5NTEyIDE3LjY5NjYgMy4zMTgyMiAxNC42NSA2Ljg3NDUxIDE0LjY1QzEwLjQzMDggMTQuNjUgMTMuMzQ5NSAxNy42OTY2IDEzLjM0OTUgMjEuNVoiIHN0cm9rZT0iI0NFRDBENiIgc3Ryb2tlLXdpZHRoPSIwLjgiLz4KPGNpcmNsZSBjeD0iMTEiIGN5PSI5IiByPSI0LjEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC44Ii8+CjxwYXRoIGQ9Ik0xNy4zNDkzIDIxLjVDMTcuMzQ5MyAyNS4zMDM0IDE0LjQzMDYgMjguMzUgMTAuODc0MyAyOC4zNUM3LjMxNzk4IDI4LjM1IDQuMzk5MjcgMjUuMzAzNCA0LjM5OTI3IDIxLjVDNC4zOTkyNyAxNy42OTY2IDcuMzE3OTggMTQuNjUgMTAuODc0MyAxNC42NUMxNC40MzA2IDE0LjY1IDE3LjM0OTMgMTcuNjk2NiAxNy4zNDkzIDIxLjVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuOCIvPgo8L2c+Cjwvc3ZnPgo=";
var it = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTEwLjUgMC41QzQuOTggMC41IDAuNSA0Ljk4IDAuNSAxMC41QzAuNSAxNi4wMiA0Ljk4IDIwLjUgMTAuNSAyMC41QzE2LjAyIDIwLjUgMjAuNSAxNi4wMiAyMC41IDEwLjVDMjAuNSA0Ljk4IDE2LjAyIDAuNSAxMC41IDAuNVpNMTAuNSAxOC41QzYuMDkgMTguNSAyLjUgMTQuOTEgMi41IDEwLjVDMi41IDYuMDkgNi4wOSAyLjUgMTAuNSAyLjVDMTQuOTEgMi41IDE4LjUgNi4wOSAxOC41IDEwLjVDMTguNSAxNC45MSAxNC45MSAxOC41IDEwLjUgMTguNVpNMTUuMDkgNi4wOEw4LjUgMTIuNjdMNS45MSAxMC4wOUw0LjUgMTEuNUw4LjUgMTUuNUwxNi41IDcuNUwxNS4wOSA2LjA4WiIKICAgICAgICBmaWxsPSJ3aGl0ZSIgLz4KPC9zdmc+CiAgICA=";
var ot = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTE1Ljk2ODkgOC41MjA4N0wxNC40NzkzIDcuMDMxMjNMMTEuNSAxMC4wMTA1TDguNTIwNzIgNy4wMzEyM0w3LjAzMTA4IDguNTIwODdMMTAuMDEwNCAxMS41MDAxTDcuMDMxMDggMTQuNDc5NEw4LjUyMDcyIDE1Ljk2OTFMMTEuNSAxMi45ODk4TDE0LjQ3OTMgMTUuOTY5MUwxNS45Njg5IDE0LjQ3OTRMMTIuOTg5NiAxMS41MDAxTDE1Ljk2ODkgOC41MjA4N1pNMTguOTQ4MiA0LjA1MTk1QzE0Ljg0NDIgLTAuMDUyMDAyNCA4LjE1NTc2IC0wLjA1MjAwMjcgNC4wNTE4MSA0LjA1MTk1Qy0wLjA1MjE0NTMgOC4xNTU5IC0wLjA1MjE0NTYgMTQuODQ0NCA0LjA1MTgxIDE4Ljk0ODNDOC4xNTU3NiAyMy4wNTIzIDE0Ljg0NDIgMjMuMDUyMyAxOC45NDgyIDE4Ljk0ODNDMjMuMDUyMSAxNC44NDQ0IDIzLjA1MjEgOC4xNTU5MSAxOC45NDgyIDQuMDUxOTVaTTUuNTQxNDUgMTcuNDU4N0MyLjI1Njc5IDE0LjE3NCAyLjI1Njc5IDguODI2MjQgNS41NDE0NSA1LjU0MTU5QzguODI2MSAyLjI1Njk0IDE0LjE3MzkgMi4yNTY5NCAxNy40NTg2IDUuNTQxNTlDMjAuNzQzMiA4LjgyNjI0IDIwLjc0MzIgMTQuMTc0IDE3LjQ1ODYgMTcuNDU4N0MxNC4xNzM5IDIwLjc0MzMgOC44MjYxIDIwLjc0MzMgNS41NDE0NSAxNy40NTg3WiIKICAgICAgICBmaWxsPSJ3aGl0ZSIgLz4KPC9zdmc+CiAgICA=";
var z = {
  pending: "pending",
  success: "success",
  error: "error",
  default: "default"
};
var m = {
  pending: "pending",
  success: "success",
  fail: "fail",
  cancelled: "cancelled",
  ignored: "ignored"
};
var Zt = Object.defineProperty;
var Ot = Object.getOwnPropertyDescriptor;
var O = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Ot(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Zt(i, r, e), e;
};
var C = class extends I {
  constructor() {
    super(...arguments), this.status = z.default, this.connected = false, this.fullWidth = false, this.theme = "radix-blue";
  }
  onClick(t) {
    this.dispatchEvent(
      new CustomEvent("onClick", {
        detail: t,
        bubbles: true,
        composed: true
      })
    );
  }
  connectedCallback() {
    super.connectedCallback(), setTimeout(() => {
      const t = this.shadowRoot.querySelector("button");
      this.resizeObserver = new ResizeObserver(() => {
        this.dispatchEvent(
          new CustomEvent("onResize", {
            bubbles: true,
            composed: false,
            detail: t
          })
        );
      }), this.resizeObserver.observe(t);
    });
  }
  disconnectedCallback() {
    var i;
    super.disconnectedCallback();
    const t = this.shadowRoot.querySelector("button");
    (i = this.resizeObserver) == null || i.unobserve(t);
  }
  render() {
    const t = () => this.status === z.pending && this.connected ? g`${_} <slot></slot>` : this.status === z.pending ? _ : !this.connected && ["success", "error"].includes(this.status) ? "" : g`<slot></slot>`, i = this.status !== "pending" && !this.connected, r = this.connected;
    return g`
      <button
        @click=${this.onClick}
        class=${u({
      logo: i,
      gradient: r
    })}
        aria-label="Radix Connect Button"
      >
        ${t()}
      </button>
    `;
  }
};
C.styles = [
  H,
  ft,
  d`
      :host {
        width: max(var(--radix-connect-button-width, 138px), 40px);
        min-width: 40px;
        display: flex;
        justify-content: flex-end;
        container-type: inline-size;
        user-select: none;
        --radix-connect-button-text-color: var(--color-light);
      }

      :host([full-width]) > button {
        width: 100%;
      }

      :host([full-width]) {
        width: 100%;
        display: inline-block;
      }

      ::slotted(*) {
        overflow: hidden;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        width: auto;
      }

      .gradient ::slotted(*) {
        padding: 0 4px;
      }

      button {
        width: max(var(--radix-connect-button-width, 138px), 40px);
        height: var(--radix-connect-button-height, 40px);
        min-width: ${Tt}px;
        min-height: ${vt}px;
        border-radius: var(--radix-connect-button-border-radius, 0);
        background-color: var(--radix-connect-button-background);
        border: 1px solid var(--radix-connect-button-border-color);
        color: var(--radix-connect-button-text-color);
        font-size: 14px;
        align-content: center;
        align-items: center;
        font-family: inherit;
        cursor: pointer;
        font-weight: 600;
        transition: background-color 0.1s cubic-bezier(0.45, 0, 0.55, 1);

        display: flex;
        gap: 3px;
        justify-content: center;
        padding: 0 10px;
      }

      button::before {
        min-height: 0.94em;
        min-width: 1.25em;
        display: block;
        -webkit-mask-position: center right;
        mask-position: center right;
        mask-repeat: no-repeat;
        -webkit-mask-repeat: no-repeat;
        background-color: var(--radix-connect-button-text-color);
        width: 16px;
      }

      button:hover {
        background-color: var(--radix-connect-button-background-hover);
      }

      button.logo::before {
        content: '';
        mask-image: url(${c(tt)});
        -webkit-mask-image: url(${c(tt)});
      }

      button.gradient.logo::before {
        background-color: var(--color-light);
      }

      :host([status='pending']) > button.gradient::before {
        display: none;
      }

      button.gradient {
        border: 1px solid transparent;
        background-repeat: no-repeat;
        background-origin: border-box;
        background-size: cover;
        background-position: center;
        background-color: var(--color-radix-blue-2);
        color: var(--color-light);
        background-image: url(${c(St)});
        padding-right: 7px;
      }

      button.gradient::before {
        content: '';
        background-color: var(--color-light);
      }

      :host([status='default']) > button.gradient::before {
        mask-image: url(${c(et)});
        -webkit-mask-image: url(${c(et)});
        width: 22px;
        min-width: 22px;
        height: 22px;
        -webkit-mask-position: center;
        mask-position: center;
      }

      :host([status='success']) > button::before {
        mask-image: url(${c(it)});
        -webkit-mask-image: url(${c(it)});
        width: 22px;
        min-width: 22px;
        height: 22px;
        -webkit-mask-position: center;
        mask-position: center;
      }

      :host([status='error']) > button::before {
        mask-image: url(${c(ot)});
        -webkit-mask-image: url(${c(ot)});
        width: 22px;
        min-width: 22px;
        height: 22px;
        -webkit-mask-position: center;
        mask-position: center;
      }

      button.gradient:hover {
        background-color: var(--color-radix-blue-1);
      }

      button:focus,
      button:focus-visible {
        outline: 0px auto -webkit-focus-ring-color;
      }

      @container (width < ${G - 0.1}px) {
        button {
          width: var(--radix-connect-button-height, 40px);
          max-width: ${G}px;
          max-height: ${G}px;
          justify-content: center;
          padding: 0;
        }
        button::before {
          -webkit-mask-position: center;
          mask-position: center;
        }
        button.gradient {
          background-image: url(${c(Et)});
          padding: 0;
        }
        button.logo::before {
          font-size: 16px;
        }
        ::slotted(*) {
          display: none;
        }
      }
    `
];
O([
  s({
    type: String,
    reflect: true
  })
], C.prototype, "status", 2);
O([
  s({
    type: Boolean
  })
], C.prototype, "connected", 2);
O([
  s({
    type: Boolean,
    reflect: true
  })
], C.prototype, "fullWidth", 2);
O([
  s({
    type: String,
    reflect: true
  })
], C.prototype, "theme", 2);
C = O([
  p("radix-button")
], C);
var rt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMDU5Xzg3NikiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xMiAyLjVDNi40OCAyLjUgMiA2Ljk4IDIgMTIuNUMyIDE4LjAyIDYuNDggMjIuNSAxMiAyMi41QzE3LjUyIDIyLjUgMjIgMTguMDIgMjIgMTIuNUMyMiA2Ljk4IDE3LjUyIDIuNSAxMiAyLjVaTTEyIDIwLjVDNy41OCAyMC41IDQgMTYuOTIgNCAxMi41QzQgOC4wOCA3LjU4IDQuNSAxMiA0LjVDMTYuNDIgNC41IDIwIDguMDggMjAgMTIuNUMyMCAxNi45MiAxNi40MiAyMC41IDEyIDIwLjVaIgogICAgICAgICAgICBmaWxsPSIjMDAzMDU3IiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDU5Xzg3NiI+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC41KSIgLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4KICAgIA==";
var at = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYxNF8yODQ4KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAxMkMyIDYuNDggNi40OCAyIDEyIDJDMTcuNTIgMiAyMiA2LjQ4IDIyIDEyQzIyIDE3LjUyIDE3LjUyIDIyIDEyIDIyQzYuNDggMjIgMiAxNy41MiAyIDEyWk03LjgxNjYxIDEyLjAwMDlMMTAuMjQ5MSAxNC40MzM0TDE2LjQyNjYgOC4yNjE3MkwxNy4yNDkxIDkuMDg0MjJMMTAuMjQ5MSAxNi4wODQyTDYuOTg4MjggMTIuODIzNEw3LjgxNjYxIDEyLjAwMDlaIiBmaWxsPSIjMDAzMDU3Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNjE0XzI4NDgiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
var nt = "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMiwxQTExLDExLDAsMSwwLDIzLDEyLDExLDExLDAsMCwwLDEyLDFabTAsMTlhOCw4LDAsMSwxLDgtOEE4LDgsMCwwLDEsMTIsMjBaIiBvcGFjaXR5PSIuMjUiLz4KPHBhdGggZD0iTTEwLjE0LDEuMTZhMTEsMTEsMCwwLDAtOSw4LjkyQTEuNTksMS41OSwwLDAsMCwyLjQ2LDEyLDEuNTIsMS41MiwwLDAsMCw0LjExLDEwLjdhOCw4LDAsMCwxLDYuNjYtNi42MUExLjQyLDEuNDIsMCwwLDAsMTIsMi42OWgwQTEuNTcsMS41NywwLDAsMCwxMC4xNCwxLjE2WiIvPgo8L3N2Zz4=";
var st = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNjE0XzI4NDkpIj4KICAgIDxwYXRoIGQ9Ik0xMiAyQzYuNDggMiAyIDYuNDggMiAxMkMyIDE3LjUyIDYuNDggMjIgMTIgMjJDMTcuNTIgMjIgMjIgMTcuNTIgMjIgMTJDMjIgNi40OCAxNy41MiAyIDEyIDJaTSAxMS4xOTQzIDEyIEwgOCA4LjgwNTcxIEwgOC44MDU3MSA4IEwgMTIgMTEuMTk0MyBMIDE1LjE5NDMgOCBMIDE2IDguODA1NzEgTCAxMi44MDU3IDEyIEwgMTYgMTUuMTk0MyBMIDE1LjE5NDMgMTYgTCAxMiAxMi44MDU3IEwgOC44MDU3MSAxNiBMIDggMTUuMTk0MyBaIiBmaWxsPSIjOEE4RkE0Ii8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF82MTRfMjg0OSI+CiAgICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4=";
var gt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI4MjJfMTkzMykiPgo8cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xNyAxM0g3VjExSDE3VjEzWiIgZmlsbD0iIzAwMzA1NyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI4MjJfMTkzMyI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
var Pt = (t) => {
  const i = /* @__PURE__ */ new Date();
  return t.getDate() == i.getDate() && t.getMonth() == i.getMonth() && t.getFullYear() == i.getFullYear();
};
var Gt = (t) => {
  const i = /* @__PURE__ */ new Date();
  return i.setDate(i.getDate() - 1), t.getDate() == i.getDate() && t.getMonth() == i.getMonth() && t.getFullYear() == i.getFullYear();
};
var ut = (t, i = " ") => {
  const r = new Date(Number(t)), o = Pt(r), e = Gt(r), a = r.toLocaleTimeString("en-Gb", {
    // en-GB is causing midnight to be 00:00
    hour: "numeric",
    minute: "numeric",
    hour12: false
  });
  return o ? `Today${i}${a}` : e ? `Yesterday${i}${a}` : `${r.getDate()} ${r.toLocaleString("en-US", {
    month: "short"
  })}${i}${a}`;
};
var Ut = Object.defineProperty;
var Yt = Object.getOwnPropertyDescriptor;
var V = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Yt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Ut(i, r, e), e;
};
var v = class extends I {
  constructor() {
    super(...arguments), this.header = "";
  }
  render() {
    const t = () => this.timestamp ? g`<div class="timestamp">${ut(this.timestamp)}</div>` : "", i = `${this.icon ? "30px" : ""} 1fr ${this.timestamp ? "42px" : ""}`;
    return g`<div class="card" style="${K({ gridTemplateColumns: i })}"><i></i><div class="content"><span>${this.header}</span><slot></slot></div>${t()}</div>`;
  }
};
v.styles = [
  d`:host{background-color:var(--radix-card-background);color:var(--radix-card-text-color);display:block;padding:11px 20px;user-select:none;border-radius:12px;width:100%;box-sizing:border-box}:host(.inverted){background-color:var(--radix-card-inverted-background);color:var(--radix-card-inverted-text-color)}:host(.inverted) .card i::before{background-color:var(--radix-card-inverted-text-color)}:host(.dimmed) .card i::before{background-color:var(--radix-card-text-dimmed-color)}:host(.dimmed) .content{color:var(--radix-card-text-dimmed-color)}.timestamp{text-align:right;color:var(--radix-card-text-dimmed-color);font-size:12px}.card{display:grid;align-items:center;column-gap:10px}i::before{content:'';display:block;-webkit-mask-size:cover;mask-size:cover;background-color:var(--radix-card-text-color)}span{display:block;font-weight:600;font-size:14px}p{margin:0}:host([icon=unchecked]) i::before{-webkit-mask-image:url('${c(rt)}');mask-image:url('${c(rt)}');width:24px;height:24px}:host([icon=pending]) i::before{-webkit-mask-image:url('${c(nt)}');mask-image:url('${c(nt)}');width:24px;height:24px;transform-origin:center;animation:spinner .75s infinite linear}@keyframes spinner{100%{transform:rotate(360deg)}}:host([icon=ignored]) i::before{-webkit-mask-image:url('${c(gt)}');mask-image:url('${c(gt)}');width:24px;height:24px}:host([icon=checked]) i::before{-webkit-mask-image:url('${c(at)}');mask-image:url('${c(at)}');width:24px;height:24px}:host([icon=error]) i::before{-webkit-mask-image:url('${c(st)}');mask-image:url('${c(st)}');width:24px;height:24px}`
];
V([
  s({
    type: String,
    reflect: true
  })
], v.prototype, "icon", 2);
V([
  s({
    type: String
  })
], v.prototype, "header", 2);
V([
  s({
    type: String,
    reflect: true
  })
], v.prototype, "timestamp", 2);
v = V([
  p("radix-card")
], v);
var ct = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0MDNfMTI3MSkiPgo8cGF0aCBkPSJNNS45OTkzNSAzLjgzMzk4VjUuMTY3MzJIMTAuMzkyN0wyLjY2NjAyIDEyLjg5NEwzLjYwNjAyIDEzLjgzNEwxMS4zMzI3IDYuMTA3MzJWMTAuNTAwN0gxMi42NjZWMy44MzM5OEg1Ljk5OTM1WiIgZmlsbD0iIzhBOEZBNCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE0MDNfMTI3MSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC41KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
var Wt = Object.defineProperty;
var Bt = Object.getOwnPropertyDescriptor;
var xt = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Bt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Wt(i, r, e), e;
};
var Y = class extends I {
  constructor() {
    super(...arguments), this.displayText = "";
  }
  render() {
    return g`<span class="link">${this.displayText} <i class="icon-north-east-arrow"></i></span>`;
  }
};
Y.styles = [
  d`.link{color:var(--radix-link-color);font-weight:600;text-decoration:none;display:flex;gap:4px;align-items:center;font-size:14px;cursor:pointer}.icon-north-east-arrow::before{content:'';display:block;-webkit-mask-size:cover;mask-size:cover;background-color:var(--radix-card-text-dimmed-color);-webkit-mask-image:url('${c(ct)}');mask-image:url('${c(ct)}');width:16px;height:16px}`
];
xt([
  s({
    type: String
  })
], Y.prototype, "displayText", 2);
Y = xt([
  p("radix-link")
], Y);
var At = "data:image/png;base64,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";
var Qt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIG9wYWNpdHk9IjAuOCI+CiAgICAgICAgPHBhdGggb3BhY2l0eT0iMC44IgogICAgICAgICAgICBkPSJNOC4xMjQ5OCAwLjU0MTc0OEgyLjE2NjY1QzEuNTcwODEgMC41NDE3NDggMS4wODMzMSAxLjAyOTI1IDEuMDgzMzEgMS42MjUwOFY4LjY2Njc1QzEuMDgzMzEgOC45NjQ2NiAxLjMyNzA2IDkuMjA4NDEgMS42MjQ5OCA5LjIwODQxQzEuOTIyOSA5LjIwODQxIDIuMTY2NjUgOC45NjQ2NiAyLjE2NjY1IDguNjY2NzVWMi4xNjY3NUMyLjE2NjY1IDEuODY4ODMgMi40MTA0IDEuNjI1MDggMi43MDgzMSAxLjYyNTA4SDguMTI0OThDOC40MjI5IDEuNjI1MDggOC42NjY2NSAxLjM4MTMzIDguNjY2NjUgMS4wODM0MUM4LjY2NjY1IDAuNzg1NDk4IDguNDIyOSAwLjU0MTc0OCA4LjEyNDk4IDAuNTQxNzQ4Wk0xMC4yOTE2IDIuNzA4NDFINC4zMzMzMUMzLjczNzQ4IDIuNzA4NDEgMy4yNDk5OCAzLjE5NTkxIDMuMjQ5OTggMy43OTE3NVYxMS4zNzUxQzMuMjQ5OTggMTEuOTcwOSAzLjczNzQ4IDEyLjQ1ODQgNC4zMzMzMSAxMi40NTg0SDEwLjI5MTZDMTAuODg3NSAxMi40NTg0IDExLjM3NSAxMS45NzA5IDExLjM3NSAxMS4zNzUxVjMuNzkxNzVDMTEuMzc1IDMuMTk1OTEgMTAuODg3NSAyLjcwODQxIDEwLjI5MTYgMi43MDg0MVpNOS43NDk5OCAxMS4zNzUxSDQuODc0OThDNC41NzcwNiAxMS4zNzUxIDQuMzMzMzEgMTEuMTMxMyA0LjMzMzMxIDEwLjgzMzRWNC4zMzM0MUM0LjMzMzMxIDQuMDM1NSA0LjU3NzA2IDMuNzkxNzUgNC44NzQ5OCAzLjc5MTc1SDkuNzQ5OThDMTAuMDQ3OSAzLjc5MTc1IDEwLjI5MTYgNC4wMzU1IDEwLjI5MTYgNC4zMzM0MVYxMC44MzM0QzEwLjI5MTYgMTEuMTMxMyAxMC4wNDc5IDExLjM3NTEgOS43NDk5OCAxMS4zNzUxWiIKICAgICAgICAgICAgZmlsbD0id2hpdGUiIC8+CiAgICA8L2c+Cjwvc3ZnPgogICAg";
var Nt = (t) => t ? `${t.slice(0, 4)}...${t.slice(
  t.length - 6,
  t.length
)}` : "";
var Ht = Object.defineProperty;
var Rt = Object.getOwnPropertyDescriptor;
var k = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Rt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Ht(i, r, e), e;
};
var A = class extends I {
  constructor() {
    super(...arguments), this.address = "", this.label = "", this.appearanceId = 0, this.tooltipVisible = false, this.copiedTooltipTimeout = 1500;
  }
  disconnectedCallback() {
    this.setTimeoutInstance && clearTimeout(this.setTimeoutInstance), super.disconnectedCallback();
  }
  render() {
    return g`<span class="label">${this.label}</span> <a class="address" target="_blank" href="${`${this.address}`}" @click="${(t) => {
      t.preventDefault(), this.dispatchEvent(
        new CustomEvent("onLinkClick", {
          bubbles: true,
          composed: true,
          detail: { type: "account", data: this.address }
        })
      );
    }}">${Nt(this.address)} <button aria-label="Copied!" class="${u({
      "tooltip-wrapper": true,
      "tooltip-visible": this.tooltipVisible
    })}"><i @click="${(t) => {
      t.preventDefault(), t.stopImmediatePropagation(), navigator.clipboard.writeText(this.address), this.tooltipVisible = true, this.setTimeoutInstance = setTimeout(() => {
        this.tooltipVisible = false;
      }, this.copiedTooltipTimeout);
    }}"></i></button></a>`;
  }
};
A.styles = [
  d`:host{display:flex;width:100%;box-sizing:border-box;justify-content:space-between;margin-top:.5rem;border-radius:12px;color:var(--color-light);font-size:14px;height:40px;align-items:center;padding:0 20px}.tooltip-wrapper{all:unset;display:inline-flex;position:relative}.tooltip-wrapper::after,.tooltip-wrapper::before{transition:opacity .1s ease-out .2s}.tooltip-wrapper::after{background:#000;color:#fff;border-radius:8px;content:attr(aria-label);padding:.5rem 1rem;position:absolute;white-space:nowrap;z-index:10;opacity:0;pointer-events:none;transform:translate(-70%,-30%);bottom:100%}.tooltip-wrapper::before{content:'';position:absolute;z-index:10;opacity:0;pointer-events:none;width:0;height:0;border:8px solid transparent;border-top-color:#000;transform:translate(-15%,25%);bottom:100%}.tooltip-wrapper.tooltip-visible::after,.tooltip-wrapper.tooltip-visible::before{opacity:1}.label{font-weight:600;color:var(--color-light);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:10px}a{color:var(--color-light);display:flex;align-items:center;gap:4px;opacity:.8;font-size:12px}i{background-image:url('${c(Qt)}');display:inline-block;background-repeat:no-repeat;background-size:cover;background-position:center bottom;width:13px;height:13px}.label,a,i{text-shadow:0 4px 3px rgba(0,0,0,.08)}:host([appearanceId='0']){background:linear-gradient(276.58deg,#01e2a0 -.6%,#052cc0 102.8%)}:host([appearanceId='1']){background:linear-gradient(276.33deg,#ff43ca -14.55%,#052cc0 102.71%)}:host([appearanceId='2']){background:linear-gradient(276.33deg,#20e4ff -14.55%,#052cc0 102.71%)}:host([appearanceId='3']){background:linear-gradient(94.8deg,#00ab84 -1.2%,#052cc0 103.67%)}:host([appearanceId='4']){background:linear-gradient(94.62deg,#ce0d98 -10.14%,#052cc0 104.1%)}:host([appearanceId='5']){background:linear-gradient(276.33deg,#052cc0 -14.55%,#0dcae4 102.71%)}:host([appearanceId='6']){background:linear-gradient(90.89deg,#003057 -2.21%,#03d597 102.16%)}:host([appearanceId='7']){background:linear-gradient(276.23deg,#f31dbe -2.1%,#003057 102.67%)}:host([appearanceId='8']){background:linear-gradient(276.48deg,#003057 -.14%,#052cc0 102.77%)}:host([appearanceId='9']){background:linear-gradient(276.32deg,#1af4b5 -5.15%,#0ba97d 102.7%)}:host([appearanceId='10']){background:linear-gradient(276.23deg,#e225b3 -2.1%,#7e0d5f 102.67%)}:host([appearanceId='11']){background:linear-gradient(276.48deg,#1f48e2 -.14%,#040b72 102.77%)}`
];
k([
  s({
    type: String
  })
], A.prototype, "address", 2);
k([
  s({
    type: String
  })
], A.prototype, "label", 2);
k([
  s({
    type: Number,
    reflect: true
  })
], A.prototype, "appearanceId", 2);
k([
  It()
], A.prototype, "tooltipVisible", 2);
k([
  It()
], A.prototype, "setTimeoutInstance", 2);
A = k([
  p("radix-account")
], A);
var Vt = Object.defineProperty;
var Xt = Object.getOwnPropertyDescriptor;
var h = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Xt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Vt(i, r, e), e;
};
var x = class extends I {
  constructor() {
    super(...arguments), this.type = "dataRequest", this.status = "pending", this.showCancel = false, this.showIgnore = false, this.timestamp = "", this.id = "", this.transactionIntentHash = "";
  }
  render() {
    const t = this.getIconFromStatus(), i = this.getStylingFromStatus(), r = {
      sendTransaction: {
        pending: "Pending Transaction",
        fail: "Transaction Failed",
        cancelled: "Transaction Cancelled",
        ignored: "Transaction Ignored",
        success: "Send transaction",
        content: g`${this.renderTxIntentHash()} ${this.status === "pending" ? g`<div class="request-content">Open your Radix Wallet app to review the transaction ${this.showCancel ? g`<div class="cancel" @click="${this.onCancel}">Cancel</div>` : g`<div class="cancel" @click="${this.onIgnore}">Ignore</div>`}</div>` : ""}`
      },
      dataRequest: {
        pending: "Data Request Pending",
        fail: "Data Request Rejected",
        cancelled: "Data Request Rejected",
        ignored: "",
        success: "Data Request",
        content: this.getRequestContentTemplate(
          "Open Your Radix Wallet App to complete the request"
        )
      },
      loginRequest: {
        pending: "Login Request Pending",
        fail: "Login Request Rejected",
        cancelled: "Login Request Rejected",
        success: "Login Request",
        ignored: "",
        content: this.getRequestContentTemplate(
          "Open Your Radix Wallet App to complete the request"
        )
      }
    };
    return g`<radix-card icon="${t}" class="${i}" timestamp="${this.timestamp}" header="${r[this.type][this.status]}">${r[this.type].content}</radix-card>`;
  }
  getRequestContentTemplate(t) {
    return this.status === m.pending ? g`<div class="request-content">${t} ${this.showCancel ? g`<div class="cancel" @click="${this.onCancel}">Cancel</div>` : ""}</div>` : "";
  }
  isErrorStatus(t) {
    return [
      m.cancelled,
      m.fail,
      m.ignored
    ].includes(t);
  }
  getIconFromStatus() {
    return this.status === m.pending ? "pending" : this.status === m.ignored ? "ignored" : this.isErrorStatus(this.status) ? "error" : "checked";
  }
  getStylingFromStatus() {
    return u({
      dimmed: this.isErrorStatus(this.status),
      inverted: this.status === "pending"
    });
  }
  onCancel(t) {
    this.dispatchEvent(
      new CustomEvent("onCancelRequestItem", {
        detail: {
          ...t,
          id: this.id
        },
        bubbles: true,
        composed: true
      })
    );
  }
  onIgnore(t) {
    this.dispatchEvent(
      new CustomEvent("onIgnoreTransactionItem", {
        detail: {
          ...t,
          id: this.id
        },
        bubbles: true,
        composed: true
      })
    );
  }
  renderTxIntentHash() {
    return this.transactionIntentHash ? g`<div class="transaction"><span class="text-dimmed">ID:</span><radix-link displayText="${Nt(this.transactionIntentHash)}" @click="${(t) => {
      t.preventDefault(), this.dispatchEvent(
        new CustomEvent("onLinkClick", {
          bubbles: true,
          composed: true,
          detail: {
            type: "transaction",
            data: this.transactionIntentHash
          }
        })
      );
    }}"></radix-link></div>` : "";
  }
};
x.styles = [
  d`:host{display:flex;width:100%;margin-bottom:10px}.text-dimmed{color:var(--radix-card-text-dimmed-color);margin-right:5px}.transaction{font-weight:600;text-decoration:none;display:flex;align-items:center;font-size:14px}.cancel{cursor:pointer;text-decoration:underline}.request-content{margin-top:5px;display:flex;flex-direction:column;gap:10px;font-size:14px}`
];
h([
  s({
    type: String
  })
], x.prototype, "type", 2);
h([
  s({
    type: String
  })
], x.prototype, "status", 2);
h([
  s({
    type: Boolean
  })
], x.prototype, "showCancel", 2);
h([
  s({
    type: Boolean
  })
], x.prototype, "showIgnore", 2);
h([
  s({
    type: String
  })
], x.prototype, "timestamp", 2);
h([
  s({
    type: String
  })
], x.prototype, "id", 2);
h([
  s({
    type: String
  })
], x.prototype, "transactionIntentHash", 2);
x = h([
  p("radix-request-card")
], x);
var Jt = Object.defineProperty;
var Ft = Object.getOwnPropertyDescriptor;
var bt = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Ft(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Jt(i, r, e), e;
};
var W = class extends I {
  constructor() {
    super(...arguments), this.requestItems = [];
  }
  render() {
    return (this.requestItems || []).map(
      (t) => g`<radix-request-card type="${t.type}" status="${t.status}" id="${t.interactionId}" ?showCancel="${t.showCancel}" timestamp="${t.createdAt}"></radix-request-card>`
    );
  }
};
W.styles = [H];
bt([
  s({ type: Array })
], W.prototype, "requestItems", 2);
W = bt([
  p("radix-request-cards")
], W);
var Kt = Object.defineProperty;
var qt = Object.getOwnPropertyDescriptor;
var $t = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? qt(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Kt(i, r, e), e;
};
var F = class extends I {
  render() {
    return g`<button><slot></slot></button>`;
  }
};
F.styles = [
  d`button{transition:background-color .1s cubic-bezier(.45,0,.55,1);border-radius:12px;border:none;background:var(--radix-button-background);color:var(--radix-button-text-color);font-size:14px;font-weight:600;padding:11px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:5px}button:hover{background:var(--radix-button-background-hover)}button:active{background:var(--radix-button-background-pressed)}:host(.primary) button{background:var(--color-radix-blue-2);color:var(--color-light)}:host(.full) button{width:100%}:host(.disabled) button,:host(.primary.disabled) button{background:var(--radix-button-disabled-background);color:var(--radix-button-disabled-text-color);cursor:default;pointer-events:none}`
];
F = $t([
  p("radix-themed-button")
], F);
var _t = Object.defineProperty;
var te = Object.getOwnPropertyDescriptor;
var f = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? te(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && _t(i, r, e), e;
};
var N = class extends I {
  constructor() {
    super(...arguments), this.isMobile = false, this.status = z.default, this.isWalletLinked = false, this.isExtensionAvailable = false, this.requestItems = [];
  }
  render() {
    let t = this.renderConnectTemplate();
    return !this.isExtensionAvailable && !this.isMobile ? t = this.renderCeNotInstalledTemplate() : !this.isWalletLinked && !this.isMobile ? t = this.renderCeNotLinkedTemplate() : this.status === z.pending && (t = this.renderRequestItemsTemplate()), g`<div class="wrapper connect-your-wallet"><img width="44" height="44" src="${At}" alt="Radix Logo"> <span class="text connect">Connect Your Radix Wallet</span></div>${t}`;
  }
  renderRequestItemsTemplate() {
    return g`<radix-request-cards class="request-cards" .requestItems="${this.requestItems}"></radix-request-cards>`;
  }
  connectNowButtonTemplate() {
    const t = (!this.isExtensionAvailable || !this.isWalletLinked) && !this.isMobile, i = this.isMobile ? g`<div class="cta-link"><radix-link displayText="Don't have the Radix Wallet?" @click="${() => {
      this.dispatchEvent(
        new CustomEvent("onLinkClick", {
          bubbles: true,
          composed: true,
          detail: { type: "getWallet" }
        })
      );
    }}"></radix-link></div>` : g``;
    return g`<radix-themed-button class="${u({
      full: true,
      primary: true,
      disabled: t
    })}" @click="${() => {
      t || this.dispatchEvent(
        new CustomEvent("onConnect", {
          bubbles: true,
          composed: true
        })
      );
    }}">Connect Now</radix-themed-button>${i}`;
  }
  renderCeNotInstalledTemplate() {
    return g`<div class="info">Before you can connect your Radix Wallet, you need the Radix Connector browser extension.</div><div class="cta-link"><radix-link displayText="Download and Setup Guide" @click="${() => {
      this.dispatchEvent(
        new CustomEvent("onLinkClick", {
          bubbles: true,
          composed: true,
          detail: { type: "setupGuide" }
        })
      );
    }}"></radix-link></div>${this.connectNowButtonTemplate()}`;
  }
  renderCeNotLinkedTemplate() {
    return g`<div class="info">To connect your Radix Wallet, you need to link it to your Radix Connector browser extension using a QR code.</div><radix-themed-button class="primary full" @click="${() => {
      this.dispatchEvent(
        new CustomEvent("onLinkClick", {
          bubbles: true,
          composed: true,
          detail: { type: "showQrCode" }
        })
      );
    }}">Open QR Code to Link Wallet</radix-themed-button><div class="cta-link"><radix-link displayText="Download and Setup Guide" @click="${() => {
      this.dispatchEvent(
        new CustomEvent("onLinkClick", {
          bubbles: true,
          composed: true,
          detail: { type: "setupGuide" }
        })
      );
    }}"></radix-link></div>${this.connectNowButtonTemplate()}`;
  }
  renderConnectTemplate() {
    return g`${this.connectNowButtonTemplate()}`;
  }
};
N.styles = [
  d`:host{width:100%;box-sizing:border-box}.wrapper.connect-your-wallet{display:flex;align-items:center;margin:12px .5rem 1.5rem;line-height:23px;justify-content:center;gap:12px}.request-cards{display:block;max-height:410px;overflow-y:auto}.card{margin-bottom:10px}.info{margin-bottom:20px;padding:0 20px;font-size:14px;line-height:18px;text-align:center}.cta-link{display:flex;justify-content:center;margin:25px 0}.text.connect{color:var(--color-text-primary);font-size:18px;width:7.2rem;font-weight:600;text-align:left}.subtitle{color:var(--radix-card-text-dimmed-color)}.mobile-wrapper{display:flex;flex-direction:column;text-align:center;align-items:center;margin-bottom:18px;margin-top:25px;font-size:14px}.mobile-wrapper .header{font-size:18px;font-weight:600;margin-bottom:5px}.mobile-wrapper .content{font-size:16px;margin-bottom:5px}`
];
f([
  s({
    type: Boolean
  })
], N.prototype, "isMobile", 2);
f([
  s({
    type: String
  })
], N.prototype, "status", 2);
f([
  s({
    type: Boolean
  })
], N.prototype, "isWalletLinked", 2);
f([
  s({
    type: Boolean
  })
], N.prototype, "isExtensionAvailable", 2);
f([
  s({
    type: Array
  })
], N.prototype, "requestItems", 2);
N = f([
  p("radix-not-connected-page")
], N);
var ee = "data:image/svg+xml;base64,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";
var ie = Object.defineProperty;
var oe = Object.getOwnPropertyDescriptor;
var P = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? oe(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && ie(i, r, e), e;
};
var y = class extends I {
  constructor() {
    super(...arguments), this.persona = "", this.personaData = [];
  }
  render() {
    return g`<radix-card><div class="${u({
      center: (this.personaData || []).length < 2,
      "persona-card": true
    })}"><div class="placeholder"><div class="${u({
      avatar: !!this.avatarUrl
    })}" style="${K({
      backgroundImage: `url(${c(this.avatarUrl)})`
    })}"></div></div><div class="content"><span class="persona">${this.persona}</span><ul>${(this.personaData || []).map((t) => g`<li>${t}</li>`)}</ul></div></div></radix-card>`;
  }
};
y.styles = [
  d`:host{display:flex;width:100%}.avatar{background-size:cover;background-repeat:no-repeat;background-position:center;border-radius:50%;width:60px;height:60px;align-self:center;border:2px solid var(--radix-avatar-border-color)}.placeholder{width:64px;height:64px;background-image:url('${c(ee)}')}.persona-card{display:grid;gap:20px;align-items:flex-start;grid-template-columns:1fr 230px}.persona-card.center{align-items:center}.persona{font-size:14px;font-weight:600;text-overflow:ellipsis;overflow:hidden;display:block;white-space:nowrap}ul{margin-top:5px;margin-bottom:0;padding-inline-start:20px}li{font-size:12px;word-break:break-word;line-height:18px}`
];
P([
  s({
    type: String,
    reflect: true
  })
], y.prototype, "icon", 2);
P([
  s({
    type: String
  })
], y.prototype, "persona", 2);
P([
  s({
    type: String
  })
], y.prototype, "avatarUrl", 2);
P([
  s({
    type: Array
  })
], y.prototype, "personaData", 2);
y = P([
  p("radix-persona-card")
], y);
var dt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMTg4XzQyOCkiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xMy43Mzc4IDQuNzYyNUMxMi42NTAzIDMuNjc1IDExLjE1NzggMyA5LjUwMDMxIDNDNi4xODUzMSAzIDMuNTA3ODEgNS42ODUgMy41MDc4MSA5QzMuNTA3ODEgMTIuMzE1IDYuMTg1MzEgMTUgOS41MDAzMSAxNUMxMi4yOTc4IDE1IDE0LjYzMDMgMTMuMDg3NSAxNS4yOTc4IDEwLjVIMTMuNzM3OEMxMy4xMjI4IDEyLjI0NzUgMTEuNDU3OCAxMy41IDkuNTAwMzEgMTMuNUM3LjAxNzgxIDEzLjUgNS4wMDAzMSAxMS40ODI1IDUuMDAwMzEgOUM1LjAwMDMxIDYuNTE3NSA3LjAxNzgxIDQuNSA5LjUwMDMxIDQuNUMxMC43NDUzIDQuNSAxMS44NTUzIDUuMDE3NSAxMi42NjUzIDUuODM1TDEwLjI1MDMgOC4yNUgxNS41MDAzVjNMMTMuNzM3OCA0Ljc2MjVaIgogICAgICAgICAgICBmaWxsPSIjMDUyQ0MwIiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8xMTg4XzQyOCI+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSkiIC8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+CiAgICA=";
var lt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMTg4XzQyNCkiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xMi43NSA1LjI1TDExLjY5MjUgNi4zMDc1TDEzLjYyNzUgOC4yNUg2VjkuNzVIMTMuNjI3NUwxMS42OTI1IDExLjY4NUwxMi43NSAxMi43NUwxNi41IDlMMTIuNzUgNS4yNVpNMyAzLjc1SDlWMi4yNUgzQzIuMTc1IDIuMjUgMS41IDIuOTI1IDEuNSAzLjc1VjE0LjI1QzEuNSAxNS4wNzUgMi4xNzUgMTUuNzUgMyAxNS43NUg5VjE0LjI1SDNWMy43NVoiCiAgICAgICAgICAgIGZpbGw9IiMwNTJDQzAiIC8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzExODhfNDI0Ij4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIgLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4KICAgIA==";
var Dt = d`:host{width:100%}.header{font-size:12px;font-weight:400;margin:15px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:100%;text-align:center}.content{overflow:auto;width:100%;margin-bottom:0;position:relative;-webkit-mask-image:linear-gradient(180deg,#000 90%,transparent 100%);mask-image:linear-gradient(180deg,#000 90%,transparent 95%)}`;
var re = Object.defineProperty;
var ae = Object.getOwnPropertyDescriptor;
var S = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? ae(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && re(i, r, e), e;
};
var b = class extends I {
  constructor() {
    super(...arguments), this.avatarUrl = "", this.persona = "", this.dAppName = "", this.personaData = [], this.accounts = [];
  }
  onUpdateData(t) {
    this.dispatchEvent(
      new CustomEvent("onUpdateData", {
        detail: t,
        bubbles: true,
        composed: true
      })
    );
  }
  onLogout(t) {
    this.dispatchEvent(
      new CustomEvent("onLogout", {
        detail: t,
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return g`<div class="header">Sharing with ${this.dAppName}</div><div class="content"><radix-persona-card avatarUrl="${this.avatarUrl}" persona="${this.persona}" .personaData="${this.personaData}"></radix-persona-card><div>${(this.accounts || []).map(
      ({ label: t, address: i, appearanceId: r }) => g`<radix-account label="${t}" address="${i}" appearanceId="${r}"></radix-account>`
    )}</div></div><div class="buttons"><radix-themed-button class="${u({
      full: true,
      disabled: this.accounts.length === 0
    })}" @click="${this.onUpdateData}"><div class="${u({
      icon: true,
      "update-data": true,
      disabled: this.accounts.length === 0
    })}"></div>Update Account Sharing</radix-themed-button><radix-themed-button class="full" @click="${this.onLogout}"><div class="icon logout"></div>Log Out</radix-themed-button></div>`;
  }
};
b.styles = [
  Dt,
  d`:host{width:100%}.icon::before{content:'';-webkit-mask-position:center;mask-position:center;-webkit-mask-size:cover;mask-size:cover;background:var(--radix-button-text-color);display:block;width:20px;height:20px}.icon.disabled::before{background:var(--radix-button-disabled-text-color)}.content{max-height:193px;overflow-x:hidden;padding-bottom:19px}.buttons{display:grid;bottom:0;width:100%;grid-template-columns:1fr 115px;grid-gap:10px;width:100%;padding-top:5px;align-items:end}.update-data::before{-webkit-mask-image:url('${c(dt)}');mask-image:url('${c(dt)}')}.logout::before{-webkit-mask-image:url('${c(lt)}');mask-image:url('${c(lt)}')}`
];
S([
  s({
    type: String
  })
], b.prototype, "avatarUrl", 2);
S([
  s({
    type: String
  })
], b.prototype, "persona", 2);
S([
  s({
    type: String
  })
], b.prototype, "dAppName", 2);
S([
  s({
    type: Array
  })
], b.prototype, "personaData", 2);
S([
  s({
    type: Array
  })
], b.prototype, "accounts", 2);
b = S([
  p("radix-sharing-page")
], b);
var ne = "data:image/svg+xml;base64,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";
var se = Object.defineProperty;
var ge = Object.getOwnPropertyDescriptor;
var ht = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? ge(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && se(i, r, e), e;
};
var B = class extends I {
  constructor() {
    super(...arguments), this.isBranded = false;
  }
  render() {
    return g`<slot></slot>`;
  }
};
B.styles = [
  d`:host{position:fixed;top:0;left:0;right:unset;height:100%;width:100%;padding:16px;box-sizing:border-box;backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);display:flex;align-items:center;justify-content:center;transition:opacity .2s;background:var(--radix-mask-background);z-index:2147483647}:host([isBranded]){align-items:flex-start;background:#000;background-image:url('${c(ne)}');background-size:cover}:host(.hide){opacity:0;pointer-events:none}:host(.show){opacity:1}`
];
ht([
  s({
    type: Boolean,
    reflect: true
  })
], B.prototype, "isBranded", 2);
B = ht([
  p("radix-mask")
], B);
var ce = Object.defineProperty;
var de = Object.getOwnPropertyDescriptor;
var X = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? de(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && ce(i, r, e), e;
};
var T = class extends I {
  constructor() {
    super(...arguments), this.requestItems = [], this.dAppName = "", this.loggedInTimestamp = "";
  }
  render() {
    return g`<div class="header">Connected to ${this.dAppName}</div><slot name="subheader"></slot>${this.loggedInTimestamp ? g`<div class="subheader">Since logged in: ${ut(this.loggedInTimestamp, ", ")}</div>` : ""}<div class="content">${(this.requestItems || []).map(
      (t) => g`<radix-request-card type="${t.type}" status="${t.status}" id="${t.interactionId}" transactionIntentHash="${t.transactionIntentHash || ""}" ?showCancel="${t.showCancel}" timestamp="${t.createdAt}"></radix-request-card>`
    )}</div>`;
  }
};
T.styles = [
  Dt,
  d`.subheader{color:var(--radix-card-text-dimmed-color);margin-top:-12px;margin-bottom:15px;text-align:center;font-size:12px}.content{padding-bottom:25px;max-height:calc(100vh - 270px)}@media (min-height:580px){.content{max-height:360px}}`
];
X([
  s({ type: Array })
], T.prototype, "requestItems", 2);
X([
  s({
    type: String
  })
], T.prototype, "dAppName", 2);
X([
  s({
    type: String
  })
], T.prototype, "loggedInTimestamp", 2);
T = X([
  p("radix-requests-page")
], T);
var le = Object.defineProperty;
var Ie = Object.getOwnPropertyDescriptor;
var M = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Ie(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && le(i, r, e), e;
};
var l = class extends I {
  constructor() {
    super(), this.theme = "radix-blue", this.dAppName = "", this.personaLabel = "", this.connected = false, this.status = z.default, this.loggedInTimestamp = "", this.showPopoverMenu = false, this.requestItems = [], this.accounts = [], this.personaData = [], this.isMobile = false, this.isWalletLinked = false, this.isExtensionAvailable = false, this.fullWidth = false, this.activeTab = "sharing", this.mode = "light", this.avatarUrl = "", this.compact = false, this.pristine = true, this.fontGoogleApiHref = "https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,600", this.initialBodyOverflow = document.body.style.overflow, this.initialBackdropFilter = "", this.parentElementWithBackdropFilter = null, this.injectFontCSS(), this.windowClickEventHandler = (t) => {
      this.showPopoverMenu && (this.contains(t.target) || (this.showPopoverMenu = false));
    }, document.addEventListener("click", this.windowClickEventHandler);
  }
  get hasSharedData() {
    return !!(this.accounts.length || this.personaData.length);
  }
  attributeChangedCallback(t, i, r) {
    super.attributeChangedCallback(t, i, r), t === "showpopovermenu" && (this.pristine = false, this.toggleBodyOverflow());
  }
  connectedCallback() {
    super.connectedCallback(), window.dispatchEvent(new Event("onConnectButtonRender")), this.dispatchEvent(
      new CustomEvent("onRender", {
        bubbles: true,
        composed: true
      })
    );
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.windowClickEventHandler), this.dispatchEvent(
      new CustomEvent("onDestroy", {
        bubbles: true,
        composed: true
      })
    );
  }
  injectFontCSS() {
    if (this.shouldSkipFontInjection())
      return;
    const t = document.createElement("link");
    t.setAttribute("rel", "stylesheet"), t.setAttribute("href", this.fontGoogleApiHref), document.head.append(t);
  }
  shouldSkipFontInjection() {
    return !!document.head.querySelector(
      `link[href|="${this.fontGoogleApiHref}"]`
    ) || document.fonts.check("16px IBM Plex Sans");
  }
  togglePopoverMenu() {
    this.pristine = false, this.showPopoverMenu = !this.showPopoverMenu, this.toggleBodyOverflow(), this.toggleParentBackdropFilter(), this.showPopoverMenu && this.dispatchEvent(
      new CustomEvent("onShowPopover", {
        bubbles: true,
        composed: true
      })
    );
  }
  toggleBodyOverflow() {
    this.isMobile && (document.body.style.overflow = this.showPopoverMenu && this.isMobile ? "hidden" : this.initialBodyOverflow);
  }
  toggleParentBackdropFilter() {
    if (this.isMobile)
      if (!this.showPopoverMenu && this.parentElementWithBackdropFilter) {
        setTimeout(() => {
          var i;
          (i = this.parentElementWithBackdropFilter) == null || i.style.setProperty(
            "backdrop-filter",
            this.initialBackdropFilter
          ), this.initialBackdropFilter = "", this.parentElementWithBackdropFilter = null;
        }, 180);
        return;
      } else {
        const i = this.findParentWithBackdropFilter(this);
        if (i === null)
          return;
        this.initialBackdropFilter = i.backdropFilter, this.parentElementWithBackdropFilter = i.element, i.element.style.backdropFilter = "none";
      }
  }
  findParentWithBackdropFilter(t) {
    if (!t)
      return null;
    const r = window.getComputedStyle(t).getPropertyValue("backdrop-filter");
    return r !== "none" ? { element: t, backdropFilter: r } : this.findParentWithBackdropFilter(t.parentElement);
  }
  connectButtonTemplate() {
    const t = this.connected ? this.personaLabel : "Connect";
    return g`<radix-button status="${this.status}" theme="${this.theme}" ?connected="${this.connected}" ?fullWidth="${this.fullWidth}" @onClick="${this.togglePopoverMenu}" @onResize="${(i) => {
      this.compact = i.detail.offsetWidth === 40;
    }}"><div>${t}</div></radix-button>`;
  }
  connectTemplate() {
    if (!this.connected)
      return g`<radix-not-connected-page status="${this.status}" ?isMobile="${this.isMobile}" .requestItems="${this.requestItems}" ?isWalletLinked="${this.isWalletLinked}" ?isExtensionAvailable="${this.isExtensionAvailable}"></radix-not-connected-page>`;
  }
  renderSharingTemplate() {
    return g`<radix-sharing-page dAppName="${this.dAppName}" avatarUrl="${this.avatarUrl}" persona="${this.personaLabel}" .personaData="${(this.personaData || []).map((t) => t.value)}" .accounts="${this.accounts}" @onLogout="${() => {
      this.dispatchEvent(
        new CustomEvent("onDisconnect", {
          bubbles: true,
          composed: true
        })
      );
    }}" @onUpdateData="${() => {
      this.accounts.length && this.dispatchEvent(
        new CustomEvent("onUpdateSharedAccounts", {
          bubbles: true,
          composed: true
        })
      );
    }}"></radix-sharing-page>`;
  }
  renderRequestItemsTemplate() {
    return g`<radix-requests-page loggedInTimestamp="${this.loggedInTimestamp}" dAppName="${this.dAppName}" .requestItems="${this.requestItems}"></radix-requests-page>`;
  }
  get showPopoverCloseButton() {
    return this.isMobile;
  }
  popoverTemplate() {
    return this.pristine ? "" : g`<radix-popover ?isMobile="${this.isMobile}" ?connected="${this.connected}" ?compact="${this.compact}" ?showCloseButton="${this.showPopoverCloseButton}" @onClosePopover="${() => {
      this.togglePopoverMenu();
    }}" class="${q({
      show: this.showPopoverMenu,
      hide: !this.showPopoverMenu,
      popoverPosition: !this.isMobile
    })}">${this.renderPopoverContentTemplate()}</radix-popover>`;
  }
  renderPopoverContentTemplate() {
    return this.connected ? g`<radix-tabs-menu active="${this.activeTab}" @onClick="${(t) => {
      this.activeTab = t.detail.value;
    }}"></radix-tabs-menu>${this.activeTab === "sharing" ? this.renderSharingTemplate() : this.renderRequestItemsTemplate()}` : this.connectTemplate();
  }
  render() {
    return g`${this.connectButtonTemplate()} ${this.isMobile ? g`<radix-mask class="${q({
      show: this.showPopoverMenu,
      hide: !this.showPopoverMenu
    })}">${this.popoverTemplate()}</radix-mask>` : this.popoverTemplate()}`;
  }
};
l.styles = [
  pt,
  H,
  d`:root{font-family:'IBM Plex Sans';margin:0;font-size:16px;line-height:24px;font-weight:400;color-scheme:light dark;color:rgba(255,255,255,.87);font-synthesis:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-text-size-adjust:100%}:host{all:initial;text-align:left;font-family:'IBM Plex Sans';position:relative;z-index:1000;display:inline-block}.mobile-wrapper{display:flex;flex-direction:column;text-align:center;align-items:center;margin-bottom:18px;margin-top:25px;font-size:14px}.mobile-wrapper .header{font-size:18px;font-weight:600;margin-bottom:5px}.mobile-wrapper .content{font-size:16px;margin-bottom:5px}.popoverPosition{position:absolute;top:calc(100% + .5rem);right:0}`
];
M([
  s({
    type: String
  })
], l.prototype, "theme", 2);
M([
  s({ type: String })
], l.prototype, "dAppName", 2);
M([
  s({ type: String })
], l.prototype, "personaLabel", 2);
M([
  s({ type: Boolean })
], l.prototype, "connected", 2);
M([
  s({
    type: String
  })
], l.prototype, "status", 2);
M([
  s({ type: String })
], l.prototype, "loggedInTimestamp", 2);
M([
  s({ type: Boolean, reflect: true })
], l.prototype, "showPopoverMenu", 2);
M([
  s({ type: Array })
], l.prototype, "requestItems", 2);
M([
  s({ type: Array })
], l.prototype, "accounts", 2);
M([
  s({
    type: Array
  })
], l.prototype, "personaData", 2);
M([
  s({
    type: Boolean
  })
], l.prototype, "isMobile", 2);
M([
  s({
    type: Boolean
  })
], l.prototype, "isWalletLinked", 2);
M([
  s({
    type: Boolean
  })
], l.prototype, "isExtensionAvailable", 2);
M([
  s({
    type: Boolean
  })
], l.prototype, "fullWidth", 2);
M([
  s({
    type: String
  })
], l.prototype, "activeTab", 2);
M([
  s({ type: String, reflect: true })
], l.prototype, "mode", 2);
M([
  s({ type: String })
], l.prototype, "avatarUrl", 2);
M([
  s({ type: Boolean, state: true })
], l.prototype, "compact", 2);
l = M([
  p("radix-connect-button")
], l);
var pe = Object.defineProperty;
var Me = Object.getOwnPropertyDescriptor;
var jt = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Me(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && pe(i, r, e), e;
};
var Q = class extends I {
  constructor() {
    super(...arguments), this.header = "Radix Wallet Connector";
  }
  render() {
    return g`<div class="radix-wallet-connector-card"><div class="radix-wallet-connector-card__logo"><img width="78" height="78" src="${At}" alt="Radix Wallet Connector Logo"></div><div class="radix-wallet-connector-card__header">${this.header}</div><slot></slot></div>`;
  }
};
Q.styles = [
  d`.radix-wallet-connector-card{background:#fff;padding:24px;border-radius:16px;position:relative;margin-top:60px;text-align:center;box-shadow:0 4px 7px 0 #00000040}.radix-wallet-connector-card__logo{position:absolute;left:0;right:0}.radix-wallet-connector-card__logo img{width:78px;height:78px;transform:translateY(-66px);box-shadow:0 4px 10px 0 rgba(0,0,0,.25);border-radius:16px}.radix-wallet-connector-card__header{margin-top:32px;margin-bottom:24px;font-size:18px;color:var(--color-grey-2)}`
];
jt([
  s({
    type: String
  })
], Q.prototype, "header", 2);
Q = jt([
  p("radix-wallet-connector-card")
], Q);
var ue = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAzNCAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3IDUuOTg1TDI4LjI5NSAyNS41SDUuNzA1TDE3IDUuOTg1Wk0xNyAwTDAuNSAyOC41SDMzLjVMMTcgMFpNMTguNSAyMUgxNS41VjI0SDE4LjVWMjFaTTE4LjUgMTJIMTUuNVYxOEgxOC41VjEyWiIgZmlsbD0iI0YwMDAwMCIvPgo8L3N2Zz4K";
var xe = Object.defineProperty;
var Ae = Object.getOwnPropertyDescriptor;
var J = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? Ae(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && xe(i, r, e), e;
};
var L = class extends I {
  constructor() {
    super(...arguments), this.header = "", this.subheader = "", this.isError = false;
  }
  render() {
    return g`<div class="connector-error">${this.isError ? g`<img src="${ue}" alt="Warning" width="33">` : ""}<h1 class="${u({ error: this.isError })}">${this.header}</h1>${this.subheader ? g`<h3>${this.subheader}</h3>` : ""}</div>`;
  }
};
L.styles = [
  d`.connector-error{display:flex;align-items:center;flex-direction:column;gap:16px}h1{font-size:24px;font-weight:700;margin:0;color:var(--color-grey-1)}.error{color:#f00000}h3{margin:0;color:var(--color-grey-2);font-size:16px;font-weight:500}`
];
J([
  s({
    type: String
  })
], L.prototype, "header", 2);
J([
  s({
    type: String
  })
], L.prototype, "subheader", 2);
J([
  s({
    type: Boolean
  })
], L.prototype, "isError", 2);
L = J([
  p("radix-wallet-connector-info")
], L);
var Ne = Object.defineProperty;
var be = Object.getOwnPropertyDescriptor;
var E = (t, i, r, o) => {
  for (var e = o > 1 ? void 0 : o ? be(i, r) : i, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (o ? n(i, r, e) : n(e)) || e);
  return o && e && Ne(i, r, e), e;
};
var D = class extends I {
  constructor() {
    super(...arguments), this.header = "", this.subheader = "", this.isError = false, this.isLoading = false, this.isHidden = true;
  }
  render() {
    return this.isHidden ? g`` : g`<radix-mask isBranded><radix-wallet-connector-card>${this.isLoading ? g`<div class="loading-container"><radix-loading-spinner></radix-loading-spinner></div>` : g`<radix-wallet-connector-info header="${this.header}" subheader="${this.subheader}" ?isError="${this.isError}"></radix-wallet-connector-info>`}</radix-wallet-connector-card></radix-mask>`;
  }
};
D.styles = [
  pt,
  d`.loading-container{display:flex;justify-content:center;padding:18px 0}`
];
E([
  s({
    type: String
  })
], D.prototype, "header", 2);
E([
  s({
    type: String
  })
], D.prototype, "subheader", 2);
E([
  s({
    type: Boolean
  })
], D.prototype, "isError", 2);
E([
  s({
    type: Boolean
  })
], D.prototype, "isLoading", 2);
E([
  s({
    type: Boolean
  })
], D.prototype, "isHidden", 2);
D = E([
  p("radix-rcfm-page")
], D);

export {
  l,
  D
};
